import { Component } from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';
import { paymentTermsText } from './payment-terms-text-stub';

@Component({
  moduleId: module.id,
  selector: 'payment-terms-modal',
  templateUrl: 'payment-terms-modal.component.html',
  styleUrls: ['payment-terms-modal.component.scss'],
})
export class PaymentTermsModalComponent extends BaseModalComponent {
  paymentTermsText = paymentTermsText;
}
